import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {TextRegularAiIcon} from 'shells/icon/svg/text-regular-ai-icon';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

import type {LeadRecapsHelpPage} from './help-lead-recaps';
import {getTitle, getBody} from './helpers';

import styles from './help-lead-recaps.module.css';

type Props = {
    page: LeadRecapsHelpPage;
};

export function HelpLeadRecapsBody(props: Props) {
    const {page} = props;

    return (
        <div>
            <OnboardingBody
                title={getTitle(page)}
                iconProps={{
                    icon: TextRegularAiIcon,
                    color: colors.aiPurplePrimary,
                }}
            >
                <div className={styles['modal-body']}>{getBody(page)}</div>
            </OnboardingBody>
        </div>
    );
}
